import Swal from "sweetalert2";
import store from "@/store";

export function exibirAlertCasaFechada() {
  const funcionamento = store.state.horaDeFuncionamentoDelivery;

  console.log("%c horario de funcionamento", 'background: yellow')
  const temHorarios = funcionamento.horario.map(e => e.periodos.length == 0 ? false : true);
  const algumTrue = temHorarios.find(e => e == true)
  if (!algumTrue) {
    console.warn("Sem horario de funcionamento cadastrados ainda");
    Swal.fire({
    title: "<p style='font-size:16px'>Estamos fechados no momento</p>",
      width: 300,
      confirmButtonText: "Entendi",
    });
    console.log("%c SEM HORARIOS DE FUNCIONAMENTO CADASTRADOS AINDA", "font-style: italic")
    return
  }


  if (!funcionamento?.horario ) {
    console.warn("Sem horario de funcionamento disponível");
    Swal.fire({
      title: "<p style='font-size:16px'>Estamos fechados no momento</p>",
      width: 300,
      confirmButtonText: "Entendi",
    });
    return;
  }

  const htmlHorario = funcionamento.horario
    .map((dia) => {
      const periodos = dia.periodos?.length
        ? dia.periodos
            .map((p) => `<div><strong>${p.inicio} - ${p.fim}</strong></div>`)
            .join("")
        : "<strong>Fechado</strong>";
      return `
        <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:8px;font-size:12px;font-style: italic;padding:2px">
          <span>${dia.dia}</span>
          <span style="color:green;">${periodos}</span>
        </div>
        <hr/>
      `;
    })
    .join("");

  Swal.fire({
    title: "<p style='font-size:16px'>Estamos fechados no momento</p>",
    html: `
      <p style="font-size:12px;padding-bottom:10px">Confira nosso horário de funcionamento:</p>
      <div style="text-align:left">${htmlHorario}</div>
    `,
    width: 300,
    confirmButtonText: "Entendi",
  });
}